/* global variables */

import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

var Salescounter = {
    packageSliderEl : document.getElementById('packageslider'),
    salesSliderEl : document.getElementById('salesslider'),
    moneySliderData : document.getElementById('js-hidden-packageslider'),
    salesSliderData : document.getElementById('js-hidden-salesslider'),
    moneyCount : document.querySelector('.js-salescounter-money-count'),
    salesPackageCount : document.querySelector('.js-salescounterperson-package-count'),
    data : variables.salescounter,
    packageRevenue : document.querySelector('.package-revenue'),
    freePackages : document.querySelector('.free-packages'),

    init: function () {
        if (Salescounter.packageSliderEl !== null  && Salescounter.salesSliderEl !== null) {
            Salescounter._initRangeSliders();
            Salescounter._setRangeSliderEvents();
        }
    },

    _initRangeSliders() {
        noUiSlider.create(Salescounter.packageSliderEl, {
            start : parseInt(Salescounter.moneySliderData.getAttribute('value')),
            connect: [true, false],
            range : {
                'min' : parseInt(Salescounter.moneySliderData.getAttribute('min')),
                'max' : parseInt(Salescounter.moneySliderData.getAttribute('max')),
            },
            // eslint-disable-next-line no-undef
            step : parseInt(Salescounter.moneySliderData.getAttribute('step')),
            ariaFormat: wNumb({
                decimals: 0,
            }),
        });

        noUiSlider.create(Salescounter.salesSliderEl, {
            start : parseInt(Salescounter.salesSliderData.getAttribute('value')),
            connect: [true, false],
            range : {
                'min' : parseInt(Salescounter.salesSliderData.getAttribute('min')),
                'max' : parseInt(Salescounter.salesSliderData.getAttribute('max')),
            },
            step : parseInt(Salescounter.salesSliderData.getAttribute('step')),
            ariaFormat: wNumb({
                decimals: 0,
            }),
        });
    },

    _setRangeSliderEvents() {
        Salescounter.packageSliderEl.noUiSlider.on('update', function () {
            this.target.parentNode.querySelector('.js-rangeslider-data').innerHTML = parseInt(this.get());
            Salescounter._updateTotal();
        });
        Salescounter.salesSliderEl.noUiSlider.on('update', function () {
            this.target.parentNode.querySelector('.js-rangeslider-data').innerHTML = parseInt(this.get());
            Salescounter._updateTotal();
        });
    },

    _updateTotal() {
        var packagesPerPerson = Salescounter.packageSliderEl.noUiSlider.get();
        var sales = Salescounter.salesSliderEl.noUiSlider.get();

        var totalPackages = packagesPerPerson * sales;

        var packages_free = 0;
        var packages_revenue = 0;

        for (var i = 0; i < Salescounter.data.length; i++) {
            if (totalPackages > Salescounter.data[i].packages_sold) {
                packages_free = Salescounter.data[i].packages_free;
                packages_revenue = Salescounter.data[i].packages_revenue;
            }
        }

        var money = packages_revenue * totalPackages;


        Salescounter._setPackages(totalPackages, money, packages_free, packages_revenue);
    },

    _setPackages(totalPackages, money, packages_free, packages_revenue) {
        Salescounter.moneyCount.innerHTML = money;
        // Salescounter.salesPackageCount.innerHTML = totalPackages;
        Salescounter.freePackages.innerHTML = packages_free;
        Salescounter.packageRevenue.innerHTML = packages_revenue;
    },

    // _updateMoneySliders(values, handle, unencoded, tap, positions) {

    // },

    // _updateSalesSlider(values, handle, unencoded, tap, positions) {

    // },
}

export default Salescounter;



// WEBPACK FOOTER //
// ./scripts/modules/salescounter.js